(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[580],{

/***/ 94355:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only":"sr-only--19d91","srOnly":"sr-only--19d91"};

/***/ }),

/***/ 21301:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"relativeContainer":"relativeContainer--a903f","notReady":"notReady--692f6","container":"container--9af8a","buttonContainer":"buttonContainer--90ead","slidesList":"slidesList--96a03","animation":"animation--1e845","slideContainer":"slideContainer--e9ebf animation--1e845","slide":"slide--1db9f","dragTransition":"dragTransition--d50e6","adjustTransition":"adjustTransition--814ff","moveTransition":"moveTransition--ad59d","leftButtonContainer":"leftButtonContainer--4a3af buttonContainer--90ead","rightButtonContainer":"rightButtonContainer--ecd91 buttonContainer--90ead","hideButton":"hideButton--f80a2"};

/***/ }),

/***/ 8979:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"disablePointerEvents":"disablePointerEvents--117b1"};

/***/ }),

/***/ 45173:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ useAsProp; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_corejs3_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70509);
/* harmony import */ var _babel_runtime_corejs3_core_js_array_is_array__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49658);
/* harmony import */ var _babel_runtime_corejs3_core_js_array_is_array__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_corejs3_core_js_array_is_array__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_corejs3_core_js_instance_some__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80945);
/* harmony import */ var _babel_runtime_corejs3_core_js_instance_some__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_corejs3_core_js_instance_some__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_corejs3_core_js_instance_reduce_right__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31529);
/* harmony import */ var _babel_runtime_corejs3_core_js_instance_reduce_right__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_corejs3_core_js_instance_reduce_right__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99084);




/* eslint-disable  import/prefer-default-export */

const isListOfComponents = t => _babel_runtime_corejs3_core_js_array_is_array__WEBPACK_IMPORTED_MODULE_0___default()(t);
const someChangedIdentity = (left, right) => _babel_runtime_corejs3_core_js_instance_some__WEBPACK_IMPORTED_MODULE_1___default()(left).call(left, (el, i) => el !== right[i]);
const createComponentFromAs = as => {
  if (isListOfComponents(as)) {
    const result = _babel_runtime_corejs3_core_js_instance_reduce_right__WEBPACK_IMPORTED_MODULE_2___default()(as).call(as, (Accumulator, LeftComp) => {
      const L = LeftComp;
      const NewComp = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(L, (0,_babel_runtime_corejs3_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__["default"])({
        as: Accumulator
      }, props));
      return NewComp;
    });
    return result;
  }
  return as;
};
const useAsProp = as => {
  const prevAsValueRef = react__WEBPACK_IMPORTED_MODULE_3__.useRef(as);
  const prevAsValue = prevAsValueRef.current;
  const toRenderRef = react__WEBPACK_IMPORTED_MODULE_3__.useRef(createComponentFromAs(as));
  const arrayChangedSize = _babel_runtime_corejs3_core_js_array_is_array__WEBPACK_IMPORTED_MODULE_0___default()(as) && _babel_runtime_corejs3_core_js_array_is_array__WEBPACK_IMPORTED_MODULE_0___default()(prevAsValue) && (prevAsValue.length !== as.length || someChangedIdentity(prevAsValue, as));
  const propChangedType = _babel_runtime_corejs3_core_js_array_is_array__WEBPACK_IMPORTED_MODULE_0___default()(prevAsValue) !== _babel_runtime_corejs3_core_js_array_is_array__WEBPACK_IMPORTED_MODULE_0___default()(as) && typeof prevAsValue !== typeof as;
  if (arrayChangedSize || propChangedType) {
    toRenderRef.current = createComponentFromAs(as);
  }
  prevAsValueRef.current = as;
  return toRenderRef.current;
};

/***/ }),

/***/ 72944:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_corejs3_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70509);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99084);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62513);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _xo_union_react_polymorphic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45173);
/* harmony import */ var _styles_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94355);
/* harmony import */ var _styles_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_css__WEBPACK_IMPORTED_MODULE_4__);







/**
 * Wrap content that should only be visible to screen readers.
 *
 * ref is forwarded to underlying element
 *
 *
 * ### When to use `ScreenReaderOnly` instead of `aria-label`
 *
 * Use this component when the screen-reader content is a superset of the visual content or in
 * cases where the existing HTML is complex (hierarchically) but is mostly correct when read out
 * loud by a screen-reader -- In this case `ScreenReaderOnly` should only enhance the information
 * that is already present in the DOM. In this scenario `ScreenReaderOnly` will also help you avoid
 * duplication of HTML text (that may be rendered in separate HTML nodes) on `aria-label`
 * properties.
 *
 */
const ScreenReaderOnly = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((_ref, ref) => {
  let {
    as,
    className,
    ...props
  } = _ref;
  const ComponentToRender = (0,_xo_union_react_polymorphic__WEBPACK_IMPORTED_MODULE_2__/* .useAsProp */ .R)(as);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ComponentToRender, (0,_babel_runtime_corejs3_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__["default"])({
    ref: ref,
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_styles_css__WEBPACK_IMPORTED_MODULE_4___default()["sr-only"]), className)
  }, props));
});
 false ? 0 : void 0;
ScreenReaderOnly.defaultProps = {
  as: 'span'
};
/* harmony default export */ __webpack_exports__["Z"] = (ScreenReaderOnly);

/***/ }),

/***/ 72848:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ lib_BaseCarousel; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/helpers/esm/extends.js
var esm_extends = __webpack_require__(70509);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js/instance/map.js
var map = __webpack_require__(93726);
var map_default = /*#__PURE__*/__webpack_require__.n(map);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js/instance/includes.js
var includes = __webpack_require__(28858);
var includes_default = /*#__PURE__*/__webpack_require__.n(includes);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(99084);
// EXTERNAL MODULE: ./node_modules/@xo-union/ui-carousel/node_modules/classnames/index.js
var classnames = __webpack_require__(22875);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@xo-union/ui-accessibility/lib/FocusBoundary/index.js
var FocusBoundary = __webpack_require__(9433);
// EXTERNAL MODULE: ./node_modules/@xo-union/react-css-modules/lib/index.js
var lib = __webpack_require__(33289);
// EXTERNAL MODULE: ./node_modules/@xo-union/react-unique-id/lib/index.js
var react_unique_id_lib = __webpack_require__(79946);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js/symbol.js
var symbol = __webpack_require__(15446);
var symbol_default = /*#__PURE__*/__webpack_require__.n(symbol);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js/number/is-integer.js
var is_integer = __webpack_require__(77422);
var is_integer_default = /*#__PURE__*/__webpack_require__.n(is_integer);
;// CONCATENATED MODULE: ./node_modules/@xo-union/ui-carousel/lib/Range/index.js



const $min = symbol_default()('min');
const $max = symbol_default()('max');
class InclusiveRange {
  constructor(min, max) {
    if (typeof min !== 'number' || typeof max !== 'number') {
      throw TypeError('Expected min and max to be numbers');
    }
    if (min > max) {
      throw TypeError('Expected min to be less than or equal to max');
    }
    if (!is_integer_default()(min) || !is_integer_default()(max)) {
      throw TypeError('Expected min and max to be integers');
    }
    this[$min] = min;
    this[$max] = max;
  }
  get min() {
    return this[$min];
  }
  get max() {
    return this[$max];
  }
  map(mapper) {
    return new this.constructor(mapper(this[$min]), mapper(this[$max]));
  }
  includes(number) {
    return number >= this.min && number <= this.max;
  }
  get length() {
    return Math.max(this.max - this.min + 1, 0);
  }
  restrict(number) {
    return Math.min(this.max, Math.max(this.min, number));
  }
}
class ExclusiveRange extends InclusiveRange {
  get min() {
    return this[$min] + 1;
  }
  get max() {
    return this[$max] - 1;
  }
}
const useInclusiveRange = (min, max) => react.useMemo(() => new InclusiveRange(min, max), [min, max]);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js/set-timeout.js
var set_timeout = __webpack_require__(79021);
var set_timeout_default = /*#__PURE__*/__webpack_require__.n(set_timeout);
;// CONCATENATED MODULE: ./node_modules/@xo-union/ui-carousel/lib/useThrotledAsyncCallback/index.js


const useThrotledAsyncCallback = function (callback) {
  let dependencies = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  const timeoutID = react.useRef();
  const newCallback = react.useCallback(function (timeout) {
    for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      rest[_key - 1] = arguments[_key];
    }
    if (timeoutID.current) {
      clearTimeout(timeoutID.current);
    }
    timeoutID.current = set_timeout_default()(() => {
      timeoutID.current = null;
      callback(...rest);
    }, timeout);
  }, dependencies);
  react.useEffect(() => () => {
    clearTimeout(timeoutID.current);
  }, []);
  return newCallback;
};
/* harmony default export */ var lib_useThrotledAsyncCallback = (useThrotledAsyncCallback);
;// CONCATENATED MODULE: ./node_modules/@xo-union/ui-carousel/lib/useNavigation/useAnimationTimeoutEffect.js

const useAnimationTimeoutEffect = (animationState, resetAnimation) => {
  react.useEffect(() => {
    /**
     * Animation is supposed to last 250ms. This will kick in if no animation happens
     */
    const timeout = 300;
    // Create a timeout to 'end' animation if no actual transition is triggered after a drag.
    //
    // For example, these events happen:
    //    MouseDown[x: 0] -> MouseMove[x: 1] -> MouseMove[x: 0] -> MouseUp[x: 0]
    //
    // In this case, the animation state changes to `ADJUST`, but because
    // no CSS transition is actually triggered, we never change from that state, since we rely on
    // `onTransitionEnd` callback to reset the animation state.

    if (animationState === 'ADJUST') {
      resetAnimation(timeout);
    }
  }, [animationState, resetAnimation]);
};
/* harmony default export */ var useNavigation_useAnimationTimeoutEffect = (useAnimationTimeoutEffect);
;// CONCATENATED MODULE: ./node_modules/@xo-union/ui-carousel/lib/useRenderRef/index.js


/**
 * Creates a ref that is always in sync with a rendered value
 *
 * This is helpful when needing to refer to a prop value without forcing
 * re-creation of cached react values or re-runs of react effects
 */
const useRenderRef = value => {
  const ref = react.useRef(value);
  ref.current = value;
  return ref;
};
/* harmony default export */ var lib_useRenderRef = (useRenderRef);
;// CONCATENATED MODULE: ./node_modules/@xo-union/ui-carousel/lib/useReducerWithChangeCallback/index.js


const useReducerWithChangeCallback = function (reducer, initialState, handleChange) {
  let dependencies = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  const [state, dispatch] = react.useReducer(reducer, initialState);

  // Use a ref for state to avoid needing to re-create dispatchWrapper when state changes
  // Re-creating dispatch wrapper causes infinite loops when dispatching an action
  // Inside of an effect
  const stateRef = lib_useRenderRef(state);
  const dispatchWrapper = react.useCallback(action => {
    const currentState = stateRef.current;
    const nextState = reducer(currentState, action);
    if (nextState !== currentState) {
      handleChange(currentState, nextState, action);
    }
    dispatch(action);
  }, [reducer, dispatch, ...dependencies]);
  return [state, dispatchWrapper];
};
/* harmony default export */ var lib_useReducerWithChangeCallback = (useReducerWithChangeCallback);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js/object/from-entries.js
var from_entries = __webpack_require__(92688);
var from_entries_default = /*#__PURE__*/__webpack_require__.n(from_entries);
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs3/core-js/object/entries.js
var entries = __webpack_require__(34699);
var entries_default = /*#__PURE__*/__webpack_require__.n(entries);
;// CONCATENATED MODULE: ./node_modules/@xo-union/ui-carousel/lib/useActionCreators/index.js




const useActionCreators = (creators, dispatch) => react.useMemo(() => {
  var _context;
  return from_entries_default()(map_default()(_context = entries_default()(creators)).call(_context, _ref => {
    let [name, creator] = _ref;
    return [name, function () {
      return dispatch(creator(...arguments));
    }];
  }));
}, [dispatch, creators]);
/* harmony default export */ var lib_useActionCreators = (useActionCreators);
;// CONCATENATED MODULE: ./node_modules/@xo-union/ui-carousel/lib/useNavigation/index.js








const HIGHER_SENSITIVITY_DELTA_RANGE = new ExclusiveRange(20, 100);
const actionTypes = {
  DRAG: 'DRAG',
  MOVE: 'MOVE',
  ADJUST: 'ADJUST',
  RESET_ANIMATION: 'RESET_ANIMATION',
  CONTROLLED_NAVIGATION_INDEX_UPDATE: 'CONTROLLED_NAVIGATION_INDEX_UPDATE'
};
const animationStates = {
  DRAG: 'DRAG',
  MOVE: 'MOVE',
  ADJUST: 'ADJUST',
  NONE: null
};
const actionCreators = {
  drag: (offset, navigationIndexRange) => ({
    type: actionTypes.DRAG,
    offset,
    navigationIndexRange
  }),
  move: (offset, navigationIndexRange) => ({
    type: actionTypes.MOVE,
    offset,
    navigationIndexRange
  }),
  adjust: navigationIndexRange => ({
    type: actionTypes.ADJUST,
    navigationIndexRange
  }),
  resetAnimation: () => ({
    type: actionTypes.RESET_ANIMATION
  }),
  controlledNavigationIndexUpdate: nextNavigationIndex => ({
    type: actionTypes.CONTROLLED_NAVIGATION_INDEX_UPDATE,
    nextNavigationIndex
  })
};
const getInitialState = function () {
  let initialIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return {
    animationState: animationStates.NONE,
    visualNavigationOffset: initialIndex,
    committedNavigationIndex: initialIndex
  };
};
const getNextIndexFromOffsetBoundToNavigationRange = (state, action) => action.navigationIndexRange.restrict(state.committedNavigationIndex + action.offset);
const reducer = (state, action) => {
  switch (action.type) {
    case actionTypes.CONTROLLED_NAVIGATION_INDEX_UPDATE:
      {
        let draggingState = {};
        if (state.animationState !== animationStates.DRAG) {
          draggingState = {
            visualNavigationOffset: action.nextNavigationIndex,
            animationState: animationStates.MOVE
          };
        }
        return {
          ...state,
          ...draggingState,
          committedNavigationIndex: action.nextNavigationIndex
        };
      }
    case actionTypes.RESET_ANIMATION:
      {
        return {
          ...state,
          animationState: animationStates.NONE
        };
      }
    case actionTypes.DRAG:
      {
        const nextIndex = getNextIndexFromOffsetBoundToNavigationRange(state, action);
        return {
          ...state,
          visualNavigationOffset: nextIndex,
          animationState: animationStates.DRAG
        };
      }
    case actionTypes.MOVE:
      {
        const nextIndex = getNextIndexFromOffsetBoundToNavigationRange(state, action);
        if (nextIndex === state.committedNavigationIndex) {
          return state;
        }
        return {
          ...state,
          visualNavigationOffset: nextIndex,
          committedNavigationIndex: nextIndex,
          animationState: animationStates.MOVE
        };
      }
    case actionTypes.ADJUST:
      {
        const delta = state.visualNavigationOffset - state.committedNavigationIndex;
        const absDelta = Math.abs(delta);
        let newNavigationIndex;
        if (includes_default()(HIGHER_SENSITIVITY_DELTA_RANGE).call(HIGHER_SENSITIVITY_DELTA_RANGE, absDelta * 100)) {
          newNavigationIndex = delta > 0 ? Math.ceil(state.visualNavigationOffset) : Math.floor(state.visualNavigationOffset);
        } else {
          newNavigationIndex = Math.round(state.visualNavigationOffset);
        }
        const finalNavigationIndex = action.navigationIndexRange.restrict(newNavigationIndex);
        return {
          ...state,
          visualNavigationOffset: finalNavigationIndex,
          committedNavigationIndex: finalNavigationIndex,
          animationState: animationStates.ADJUST
        };
      }
    default:
      {
        return state;
      }
  }
};
const useNavigation = (props, _ref) => {
  let {
    totalSlidesCount,
    visibleSlidesCount
  } = _ref;
  const isControlled = react.useRef(typeof props.navigationIndex !== 'undefined');
  const initialState = isControlled.current ? getInitialState(props.navigationIndex) : getInitialState(props.navigationIndexDefaultValue);

  /**
   * Use a ref to call the onNavigationChange callback in `useEffect`. This is helpful to ensure the
   * effect always has the latest version of the callback, without triggering the effect every time
   * the callback changes.
   */
  const onNavigationIndexChangeRef = lib_useRenderRef(props.onNavigationIndexChange);
  const onNavigationRangeChangeRef = lib_useRenderRef(props.onNavigationRangeChange);
  const onStateChange = react.useCallback((currentState, nextState, action) => {
    if (action.type === actionTypes.CONTROLLED_NAVIGATION_INDEX_UPDATE) {
      return;
    }
    if (nextState.committedNavigationIndex !== currentState.committedNavigationIndex) {
      onNavigationIndexChangeRef.current(nextState.committedNavigationIndex);
    }
  }, []);
  const [state, dispatch] = lib_useReducerWithChangeCallback(reducer, initialState, onStateChange);
  const actions = lib_useActionCreators(actionCreators, dispatch);
  const visibleSlidesIndexRange = useInclusiveRange(state.committedNavigationIndex, state.committedNavigationIndex + Math.max(visibleSlidesCount - 1, 0));
  const pageSize = props.pagination === 'auto' ? visibleSlidesIndexRange.length : props.pagination;
  const navigationIndexRange = useInclusiveRange(0, totalSlidesCount - visibleSlidesCount);
  const adjust = react.useCallback(() => {
    actions.adjust(navigationIndexRange);
  }, [navigationIndexRange, actions.adjust]);
  const resetAnimation = lib_useThrotledAsyncCallback(() => {
    actions.resetAnimation();
  }, [dispatch]);

  /**
   * Side-effects
   */

  useNavigation_useAnimationTimeoutEffect(state.animationState, resetAnimation);
  const adjustRef = lib_useRenderRef(adjust);
  react.useEffect(() => {
    onNavigationRangeChangeRef.current(navigationIndexRange);
    adjustRef.current();
  }, [navigationIndexRange]);
  if (state.committedNavigationIndex !== props.navigationIndex && isControlled.current) {
    actions.controlledNavigationIndexUpdate(props.navigationIndex);
  }
  return react.useMemo(() => {
    const move = offset => {
      actions.move(offset, navigationIndexRange);
    };
    const moveLeft = () => {
      move(-pageSize);
    };
    const moveRight = () => {
      move(pageSize);
    };
    const drag = offset => {
      actions.drag(offset, navigationIndexRange);
    };
    const canMove = offset => {
      const nextIndex = state.committedNavigationIndex + offset;
      return includes_default()(navigationIndexRange).call(navigationIndexRange, nextIndex);
    };
    return {
      // actions
      move,
      moveLeft,
      moveRight,
      drag,
      adjust,
      resetAnimation,
      // state
      visualNavigationOffset: state.visualNavigationOffset,
      committedNavigationIndex: state.committedNavigationIndex,
      animationState: state.animationState,
      visibleSlidesIndexRange,
      navigationIndexRange,
      // selectors
      canMove
    };
  }, [actions, state, adjust, resetAnimation, pageSize, navigationIndexRange, visibleSlidesIndexRange]);
};
/* harmony default export */ var lib_useNavigation = (useNavigation);
;// CONCATENATED MODULE: ./node_modules/@xo-union/ui-carousel/lib/getSlideTranslate/index.js
const getSlideTranslate = _ref => {
  let {
    visualOffset,
    alignment,
    visibleSlidesCount,
    extraPixels
  } = _ref;
  const relativeX = 100 * -visualOffset;
  if (alignment === 'left' || extraPixels === 0 || visibleSlidesCount === 0) {
    return `${relativeX}%`;
  }

  // Extra space is added to right align slides at the end of navigation
  if (alignment === 'right') {
    return `calc(${relativeX}% + ${extraPixels}px)`;
  }

  // Extra space is devided by two to center slides while navigation is somewhere
  // in the middle
  if (alignment === 'center') {
    return `calc(${relativeX}% + ${extraPixels / 2}px)`;
  }
  throw new Error('Alignment should be set to left, center, or right');
};
/* harmony default export */ var lib_getSlideTranslate = (getSlideTranslate);
// EXTERNAL MODULE: ./node_modules/@xo-union/ui-accessibility/lib/ScreenReaderOnly/index.js
var ScreenReaderOnly = __webpack_require__(72944);
;// CONCATENATED MODULE: ./node_modules/@xo-union/ui-carousel/lib/humanTerms.js



const plural = term => {
  if (typeof term === 'string') {
    return term;
  }
  const value = term.plural;
  if (!value) {
    throw new Error('Expected term to have a plural variation. Use a string or an object with a property named `plural`');
  }
  return value;
};
const singular = term => {
  if (typeof term === 'string') {
    return term;
  }
  const value = term.singular;
  if (!value) {
    throw new Error('Expected term to have a singular variation. Use a string or an object with a property named `singular`');
  }
  return value;
};
const humanTermType = keys => PropTypes.shape(_Object$fromEntries(_mapInstanceProperty(keys).call(keys, key => [key, PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
  singular: PropTypes.string,
  plural: PropTypes.string
})])])));
;// CONCATENATED MODULE: ./node_modules/@xo-union/ui-carousel/lib/ScreenReaderDescription/index.js







const ScreenReaderDescription = _ref => {
  let {
    id,
    terms,
    visibleSlidesIndexRange,
    totalSlidesCount,
    containerRef
  } = _ref;
  const humanReadableRange = map_default()(visibleSlidesIndexRange).call(visibleSlidesIndexRange, num => num + 1);
  const {
    min,
    max
  } = humanReadableRange;
  const announcementTimeout = react.useRef();
  const [shouldAnnounceChanges, setShouldAnnounceChanges] = react.useState(false);

  /**
   * Avoid announcing state of carousels on page load and resize, only do it on change
   * when focused on an element in the carousel
   */
  react.useEffect(() => {
    if (containerRef.current.contains(document.activeElement)) {
      setShouldAnnounceChanges(true);
    }
    clearTimeout(announcementTimeout.current);
    announcementTimeout.current = set_timeout_default()(() => {
      setShouldAnnounceChanges(false);
    }, 2000);
    return () => {
      clearTimeout(announcementTimeout.current);
    };
  }, [min, max, containerRef]);
  const style = shouldAnnounceChanges ? undefined : {
    display: 'none'
  };
  const countPhrase = humanReadableRange.length === 1 ? `${singular(terms.slides)} number ${min}` : `${plural(terms.slides)} ${min} to ${max}`;
  return /*#__PURE__*/react.createElement(ScreenReaderOnly/* default */.Z, {
    "aria-live": "assertive",
    "aria-atomic": "true",
    style: style,
    id: id
  }, `Showing ${countPhrase} out of ${totalSlidesCount}`);
};
 false ? 0 : void 0;
/* harmony default export */ var lib_ScreenReaderDescription = (ScreenReaderDescription);
;// CONCATENATED MODULE: ./node_modules/@xo-union/ui-carousel/lib/getAlignmentClassName/index.js
const getAlignmentClassName = (alignment, classes) => {
  switch (alignment) {
    case 'left':
      return 'isLeftAligned' in classes && classes.isLeftAligned;
    case 'right':
      return 'isRightAligned' in classes && classes.isRightAligned;
    case 'center':
      return 'isCenterAligned' in classes && classes.isCenterAligned;
    default:
      return false;
  }
};
/* harmony default export */ var lib_getAlignmentClassName = (getAlignmentClassName);
// EXTERNAL MODULE: ./node_modules/@xo-union/ui-carousel/lib/useDraggable/styles.css
var styles = __webpack_require__(8979);
var styles_default = /*#__PURE__*/__webpack_require__.n(styles);
;// CONCATENATED MODULE: ./node_modules/@xo-union/ui-carousel/lib/useDraggable/base.js


const DRAG_PIXEL_THRESHOLD = 10;
const useDraggable = _ref => {
  let {
    onDrag,
    onDragEnd
  } = _ref;
  const slideElementRef = react.useRef(null);
  const originX = react.useRef(null);
  const [isDragging, setIsDragging] = react.useState(false);
  const doDrag = react.useCallback(distance => {
    onDrag({
      distance,
      target: slideElementRef.current
    });
    setIsDragging(true);
  }, [onDrag]);
  const endDrag = react.useCallback(() => {
    if (isDragging) {
      onDragEnd();
    }
    setIsDragging(false);
    originX.current = null;
    slideElementRef.current = null;
  }, [onDragEnd, isDragging]);

  /**
   * Global handlers
   */
  react.useEffect(() => {
    const onMouseOut = evt => {
      if (originX.current !== null && (!evt.relatedTarget || evt.relatedTarget.nodeName === 'HTML')) {
        endDrag();
      }
    };
    const onMouseUp = evt => {
      endDrag();
      evt.preventDefault();
    };
    const onMouseMove = evt => {
      if (originX.current === null) {
        return;
      }
      const difference = originX.current - evt.clientX;
      if (Math.abs(difference) >= 15) {
        doDrag(difference);
        evt.preventDefault();
      }
    };
    document.addEventListener('mouseup', onMouseUp);
    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseout', onMouseOut);
    return () => {
      document.removeEventListener('mouseup', onMouseUp);
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseout', onMouseOut);
    };
  }, [isDragging, originX, onDrag, onDragEnd, doDrag, endDrag]);

  /**
   * Draggable container handlers
   */
  return react.useMemo(() => {
    const onMouseDown = evt => {
      originX.current = evt.clientX;
      slideElementRef.current = evt.target;
      evt.preventDefault();
    };
    const onDragStart = evt => {
      evt.preventDefault();
    };
    const onTouchStart = evt => {
      originX.current = evt.touches[0].clientX;
      slideElementRef.current = evt.target;
      evt.preventDefault();
    };
    const onTouchMove = evt => {
      if (originX.current === null) {
        return;
      }
      const difference = originX.current - evt.touches[0].clientX;
      if (Math.abs(difference) < DRAG_PIXEL_THRESHOLD) {
        return;
      }
      doDrag(difference);
      evt.preventDefault();
    };
    return {
      onDragStart,
      onTouchStart,
      onTouchMove,
      onTouchEnd: endDrag,
      onMouseDown,
      // Disable pointer events to avoid accidentally clicking on links in carousel
      // While intention is to scroll
      className: isDragging ? (styles_default()).disablePointerEvents : ''
    };
  }, [isDragging, originX, doDrag, endDrag]);
};
/* harmony default export */ var base = (useDraggable);
;// CONCATENATED MODULE: ./node_modules/@xo-union/ui-carousel/lib/useDraggable/index.js


const useDraggable_useDraggable = _ref => {
  let {
    navigation
  } = _ref;
  const onDrag = react.useCallback(_ref2 => {
    let {
      distance,
      target
    } = _ref2;
    const relativeDistance = distance / target.clientWidth;
    navigation.drag(relativeDistance);
  }, [navigation]);
  return base({
    onDrag,
    onDragEnd: navigation.adjust
  });
};
/* harmony default export */ var lib_useDraggable = (useDraggable_useDraggable);
;// CONCATENATED MODULE: ./node_modules/@xo-union/ui-carousel/lib/getTransitionClassName/index.js
const getTransitionClassName = (animationState, classes) => {
  if (!animationState) {
    return '';
  }
  if (animationState === 'ADJUST') {
    return classes.adjustTransition;
  }
  if (animationState === 'MOVE') {
    return classes.moveTransition;
  }
  if (animationState === 'DRAG') {
    return classes.dragTransition;
  }
  throw new Error(`Unexpected animation state in #getTransitionClassName: ${animationState}`);
};
/* harmony default export */ var lib_getTransitionClassName = (getTransitionClassName);
// EXTERNAL MODULE: ./node_modules/@xo-union/ui-carousel/lib/BaseCarousel/styles.css
var BaseCarousel_styles = __webpack_require__(21301);
var BaseCarousel_styles_default = /*#__PURE__*/__webpack_require__.n(BaseCarousel_styles);
;// CONCATENATED MODULE: ./node_modules/@xo-union/ui-carousel/lib/useFallbackRef/index.js

const useFallbackRef = (givenRef, initialValue) => {
  const fallbackRef = react.useRef(initialValue);
  if (givenRef) {
    return givenRef;
  }
  return fallbackRef;
};
/* harmony default export */ var lib_useFallbackRef = (useFallbackRef);
;// CONCATENATED MODULE: ./node_modules/@xo-union/ui-carousel/lib/BaseCarousel/index.js




















/**
 * Carousel container.
 */
const BaseCarousel = props => {
  var _context;
  const {
    renderNextButton: NextButton,
    renderPrevButton: PrevButton,
    classes: classesProp,
    id,
    srDescriptionID,
    slideIDPrefix: slideIDPrefixProp,
    terms,
    children,
    slideRole,
    carouselRole,
    listRole,
    alignment: getAlignment,
    // navigation props
    navigationIndex,
    navigationIndexDefaultValue,
    onNavigationIndexChange,
    onNavigationRangeChange,
    pagination,
    gutter,
    internals: {
      containerRef: givenContainerRef,
      totalSlidesCount,
      visibleSlidesCount,
      isReadyToRender,
      slideWidthValue,
      extraPixels
    }
  } = props;
  const containerRef = lib_useFallbackRef(givenContainerRef);
  const hasSlideOverflow = totalSlidesCount > visibleSlidesCount;
  const navigationProps = {
    navigationIndex,
    navigationIndexDefaultValue,
    onNavigationIndexChange,
    onNavigationRangeChange,
    pagination
  };
  const classes = (0,lib.useClasses)((BaseCarousel_styles_default()), classesProp);
  const slideIDPrefix = (0,react_unique_id_lib/* useUniqueID */.h)(slideIDPrefixProp);
  const slideContainerID = (0,react_unique_id_lib/* useUniqueID */.h)(id);
  const screenReaderDescriptionID = (0,react_unique_id_lib/* useUniqueID */.h)(srDescriptionID);
  const navigation = lib_useNavigation(navigationProps, {
    visibleSlidesCount,
    totalSlidesCount
  });
  const draggableProps = lib_useDraggable({
    navigation
  });
  const alignment = getAlignment({
    currentIndex: navigation.committedNavigationIndex,
    hasSlideOverflow,
    minIndex: navigation.navigationIndexRange.min,
    maxIndex: navigation.navigationIndexRange.max
  });
  const slideTranslateValue = lib_getSlideTranslate({
    visualOffset: navigation.visualNavigationOffset,
    alignment,
    visibleSlidesCount,
    extraPixels
  });
  const halfGutter = `${gutter ? gutter / 2 : 0}px`;
  const finalListRole = listRole || (visibleSlidesCount === 1 ? 'presentation' : 'list');
  const finalListItemRole = finalListRole === 'list' ? 'listitem' : 'presentation';
  return /*#__PURE__*/react.createElement("div", {
    style: {
      '--carousel-half-gutter': halfGutter,
      '--carousel-slide-width': slideWidthValue,
      '--carousel-slide-translate': slideTranslateValue
    },
    className: classnames_default()(classes.relativeContainer, lib_getAlignmentClassName(alignment, classes), lib_getTransitionClassName(navigation.animationState, classes), {
      [classes.notReady]: !isReadyToRender
    })
  }, /*#__PURE__*/react.createElement("div", {
    ref: containerRef,
    className: classes.container,
    role: carouselRole,
    id: slideContainerID,
    "aria-roledescription": "carousel",
    "aria-label": singular(terms.carousel),
    "aria-describedby": screenReaderDescriptionID
  }, /*#__PURE__*/react.createElement(lib_ScreenReaderDescription, {
    id: screenReaderDescriptionID,
    containerRef: containerRef,
    visibleSlidesIndexRange: navigation.visibleSlidesIndexRange,
    terms: terms,
    totalSlidesCount: totalSlidesCount
  }), /*#__PURE__*/react.createElement("div", {
    className: classes.leftButtonContainer
  }, /*#__PURE__*/react.createElement(PrevButton, {
    "aria-controls": `${slideContainerID} ${screenReaderDescriptionID}`,
    "aria-label": `See previous ${singular(terms.carousel)} page`,
    className: classnames_default()('prevButton' in classes && classes.prevButton, !navigation.canMove(-1) && classes.hideButton),
    disabled: !navigation.canMove(-1),
    onClick: navigation.moveLeft
  })), /*#__PURE__*/react.createElement("ul", (0,esm_extends["default"])({
    role: finalListRole
  }, draggableProps, {
    onTransitionEnd: navigation.resetAnimation,
    className: classnames_default()(draggableProps.className, classes.slidesList)
  }), map_default()(_context = react.Children).call(_context, children, (child, i) => {
    var _context2;
    const isVisible = includes_default()(_context2 = navigation.visibleSlidesIndexRange).call(_context2, i);
    return /*#__PURE__*/react.createElement(FocusBoundary/* FocusBoundary */.A, {
      enabled: isVisible
    }, /*#__PURE__*/react.createElement("li", {
      role: finalListItemRole,
      "aria-hidden": isVisible ? undefined : true,
      className: classes.slideContainer
    }, /*#__PURE__*/react.createElement("div", {
      id: [slideIDPrefix, i].join('--'),
      role: slideRole,
      "aria-roledescription": "slide",
      "aria-label": singular(terms.slides),
      className: classes.slide
    }, child)));
  })), /*#__PURE__*/react.createElement("div", {
    className: classes.rightButtonContainer
  }, /*#__PURE__*/react.createElement(NextButton, {
    "aria-controls": `${slideContainerID} ${screenReaderDescriptionID}`,
    "aria-label": `See next ${singular(terms.carousel)} page`,
    className: classnames_default()('nextButton' in classes && classes.nextButton, !navigation.canMove(1) && classes.hideButton),
    disabled: !navigation.canMove(1),
    onClick: navigation.moveRight
  }))));
};
 false ? 0 : void 0;
BaseCarousel.defaultProps = {
  slideRole: 'group',
  carouselRole: 'group',
  renderPrevButton: () => null,
  renderNextButton: () => null,
  terms: {
    slides: {
      plural: 'slides',
      singular: 'slide'
    },
    carousel: 'carousel'
  }
};
/* harmony default export */ var lib_BaseCarousel = (BaseCarousel);

/***/ }),

/***/ 70580:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_corejs3_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70509);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99084);
/* harmony import */ var lodash_noop__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21818);
/* harmony import */ var lodash_noop__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_noop__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _BaseCarousel_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72848);
/* harmony import */ var _getSlideCount_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58709);
/* harmony import */ var _getDefaultAlignment_index_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71493);










/**
 * An alternate implementation of carousel that renders every slide as fluid block containers (taking up 100% of the available space depending on the number of desired visible slots). This implementation has better render performance than the default Carousel because it only uses CSS to render slides at the appropriate size and it doesn't depend on JS to load for the first render (hence has better SSR performance and is ideal for content above the fold).
 */
const CarouselWithStaticVisibleSlots = props => {
  const {
    children,
    visibleSlots: visibleSlideSlots,
    ...restProps
  } = props;
  const totalSlidesCount = (0,_getSlideCount_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(children);
  const visibleSlidesCount = Math.min(visibleSlideSlots, totalSlidesCount);
  const slideWidthPercent = 100 / visibleSlidesCount;
  const slideWidthValue = `${slideWidthPercent}%`;
  const isReadyToRender = true;
  const extraPixels = 0;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_BaseCarousel_index_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_babel_runtime_corejs3_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__["default"])({}, restProps, {
    internals: {
      totalSlidesCount,
      slideWidthValue,
      isReadyToRender,
      visibleSlidesCount,
      extraPixels
    }
  }), children);
};
 false ? 0 : void 0;
CarouselWithStaticVisibleSlots.defaultProps = {
  pagination: 1,
  visibleSlots: 1,
  slideRole: 'group',
  carouselRole: 'group',
  alignment: _getDefaultAlignment_index_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z,
  renderPrevButton: () => null,
  renderNextButton: () => null,
  terms: {
    slides: {
      plural: 'slides',
      singular: 'slide'
    },
    carousel: 'carousel'
  },
  onNavigationIndexChange: (lodash_noop__WEBPACK_IMPORTED_MODULE_1___default()),
  onNavigationRangeChange: (lodash_noop__WEBPACK_IMPORTED_MODULE_1___default())
};
/* harmony default export */ __webpack_exports__["Z"] = (CarouselWithStaticVisibleSlots);

/***/ }),

/***/ 71493:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
const getDefaultAlignment = _ref => {
  let {
    currentIndex,
    minIndex,
    maxIndex,
    hasSlideOverflow
  } = _ref;
  if (!hasSlideOverflow) {
    // There aren't enough slides
    return 'center';
  }
  if (currentIndex === maxIndex) {
    return 'right';
  }
  if (currentIndex === minIndex) {
    return 'left';
  }
  return 'center';
};
/* harmony default export */ __webpack_exports__["Z"] = (getDefaultAlignment);

/***/ }),

/***/ 58709:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99084);

const getSlideCount = children => react__WEBPACK_IMPORTED_MODULE_0__.Children.count(children);
/* harmony default export */ __webpack_exports__["Z"] = (getSlideCount);

/***/ }),

/***/ 98466:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(53515);

module.exports = parent;


/***/ }),

/***/ 75436:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(13982);

module.exports = parent;


/***/ }),

/***/ 99616:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(80234);

module.exports = parent;


/***/ }),

/***/ 36887:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(67123);

module.exports = parent;


/***/ }),

/***/ 98105:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(1699);

module.exports = parent;


/***/ }),

/***/ 77340:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(98325);
var path = __webpack_require__(3999);

module.exports = path.Array.isArray;


/***/ }),

/***/ 294:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(36626);
var entryVirtual = __webpack_require__(65974);

module.exports = entryVirtual('Array').reduceRight;


/***/ }),

/***/ 21337:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(75468);
var entryVirtual = __webpack_require__(65974);

module.exports = entryVirtual('Array').some;


/***/ }),

/***/ 41186:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isPrototypeOf = __webpack_require__(59433);
var method = __webpack_require__(294);

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.reduceRight;
  return it === ArrayPrototype || (isPrototypeOf(ArrayPrototype, it) && own === ArrayPrototype.reduceRight) ? method : own;
};


/***/ }),

/***/ 46395:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isPrototypeOf = __webpack_require__(59433);
var method = __webpack_require__(21337);

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.some;
  return it === ArrayPrototype || (isPrototypeOf(ArrayPrototype, it) && own === ArrayPrototype.some) ? method : own;
};


/***/ }),

/***/ 5687:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(83904);
var path = __webpack_require__(3999);

module.exports = path.Number.isInteger;


/***/ }),

/***/ 46938:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(81141);
__webpack_require__(43402);
var path = __webpack_require__(3999);

module.exports = path.Object.fromEntries;


/***/ }),

/***/ 81463:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(3598);


/***/ }),

/***/ 18471:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(99719);


/***/ }),

/***/ 14653:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(30103);


/***/ }),

/***/ 56346:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(4216);


/***/ }),

/***/ 80672:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(18429);


/***/ }),

/***/ 3598:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(98466);

module.exports = parent;


/***/ }),

/***/ 99719:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(75436);

module.exports = parent;


/***/ }),

/***/ 30103:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(99616);

module.exports = parent;


/***/ }),

/***/ 4216:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(36887);

module.exports = parent;


/***/ }),

/***/ 18429:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(98105);

module.exports = parent;


/***/ }),

/***/ 12748:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var classof = __webpack_require__(88531);
var getMethod = __webpack_require__(8516);
var isNullOrUndefined = __webpack_require__(42283);
var Iterators = __webpack_require__(75942);
var wellKnownSymbol = __webpack_require__(81132);

var ITERATOR = wellKnownSymbol('iterator');

module.exports = function (it) {
  if (!isNullOrUndefined(it)) return getMethod(it, ITERATOR)
    || getMethod(it, '@@iterator')
    || Iterators[classof(it)];
};


/***/ }),

/***/ 98399:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var call = __webpack_require__(85837);
var aCallable = __webpack_require__(23188);
var anObject = __webpack_require__(33903);
var tryToString = __webpack_require__(4101);
var getIteratorMethod = __webpack_require__(12748);

var $TypeError = TypeError;

module.exports = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
  if (aCallable(iteratorMethod)) return anObject(call(iteratorMethod, argument));
  throw $TypeError(tryToString(argument) + ' is not iterable');
};


/***/ }),

/***/ 61119:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(81132);
var Iterators = __webpack_require__(75942);

var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};


/***/ }),

/***/ 10742:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(49949);

var floor = Math.floor;

// `IsIntegralNumber` abstract operation
// https://tc39.es/ecma262/#sec-isintegralnumber
// eslint-disable-next-line es/no-number-isinteger -- safe
module.exports = Number.isInteger || function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),

/***/ 67549:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var bind = __webpack_require__(2733);
var call = __webpack_require__(85837);
var anObject = __webpack_require__(33903);
var tryToString = __webpack_require__(4101);
var isArrayIteratorMethod = __webpack_require__(61119);
var lengthOfArrayLike = __webpack_require__(48368);
var isPrototypeOf = __webpack_require__(59433);
var getIterator = __webpack_require__(98399);
var getIteratorMethod = __webpack_require__(12748);
var iteratorClose = __webpack_require__(59783);

var $TypeError = TypeError;

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var ResultPrototype = Result.prototype;

module.exports = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_RECORD = !!(options && options.IS_RECORD);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind(unboundFunction, that);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose(iterator, 'normal', condition);
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_RECORD) {
    iterator = iterable.iterator;
  } else if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (!iterFn) throw $TypeError(tryToString(iterable) + ' is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = lengthOfArrayLike(iterable); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && isPrototypeOf(ResultPrototype, result)) return result;
      } return new Result(false);
    }
    iterator = getIterator(iterable, iterFn);
  }

  next = IS_RECORD ? iterable.next : iterator.next;
  while (!(step = call(next, iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose(iterator, 'throw', error);
    }
    if (typeof result == 'object' && result && isPrototypeOf(ResultPrototype, result)) return result;
  } return new Result(false);
};


/***/ }),

/***/ 59783:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var call = __webpack_require__(85837);
var anObject = __webpack_require__(33903);
var getMethod = __webpack_require__(8516);

module.exports = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject(iterator);
  try {
    innerResult = getMethod(iterator, 'return');
    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = call(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject(innerResult);
  return value;
};


/***/ }),

/***/ 98325:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $ = __webpack_require__(37377);
var isArray = __webpack_require__(79851);

// `Array.isArray` method
// https://tc39.es/ecma262/#sec-array.isarray
$({ target: 'Array', stat: true }, {
  isArray: isArray
});


/***/ }),

/***/ 36626:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(37377);
var $reduceRight = (__webpack_require__(72312).right);
var arrayMethodIsStrict = __webpack_require__(15419);
var CHROME_VERSION = __webpack_require__(59483);
var IS_NODE = __webpack_require__(5900);

// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var CHROME_BUG = !IS_NODE && CHROME_VERSION > 79 && CHROME_VERSION < 83;
var FORCED = CHROME_BUG || !arrayMethodIsStrict('reduceRight');

// `Array.prototype.reduceRight` method
// https://tc39.es/ecma262/#sec-array.prototype.reduceright
$({ target: 'Array', proto: true, forced: FORCED }, {
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduceRight(this, callbackfn, arguments.length, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ 75468:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(37377);
var $some = (__webpack_require__(16918).some);
var arrayMethodIsStrict = __webpack_require__(15419);

var STRICT_METHOD = arrayMethodIsStrict('some');

// `Array.prototype.some` method
// https://tc39.es/ecma262/#sec-array.prototype.some
$({ target: 'Array', proto: true, forced: !STRICT_METHOD }, {
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ 83904:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $ = __webpack_require__(37377);
var isIntegralNumber = __webpack_require__(10742);

// `Number.isInteger` method
// https://tc39.es/ecma262/#sec-number.isinteger
$({ target: 'Number', stat: true }, {
  isInteger: isIntegralNumber
});


/***/ }),

/***/ 43402:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $ = __webpack_require__(37377);
var iterate = __webpack_require__(67549);
var createProperty = __webpack_require__(85968);

// `Object.fromEntries` method
// https://github.com/tc39/proposal-object-from-entries
$({ target: 'Object', stat: true }, {
  fromEntries: function fromEntries(iterable) {
    var obj = {};
    iterate(iterable, function (k, v) {
      createProperty(obj, k, v);
    }, { AS_ENTRIES: true });
    return obj;
  }
});


/***/ }),

/***/ 53515:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(77340);

module.exports = parent;


/***/ }),

/***/ 13982:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(41186);

module.exports = parent;


/***/ }),

/***/ 80234:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(46395);

module.exports = parent;


/***/ }),

/***/ 67123:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(5687);

module.exports = parent;


/***/ }),

/***/ 1699:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(46938);
__webpack_require__(16490);

module.exports = parent;


/***/ }),

/***/ 49658:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(81463);

/***/ }),

/***/ 31529:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(18471);

/***/ }),

/***/ 80945:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(14653);

/***/ }),

/***/ 77422:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(56346);

/***/ }),

/***/ 92688:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(80672);

/***/ }),

/***/ 62513:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = '';

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (arg) {
				classes = appendClass(classes, parseValue(arg));
			}
		}

		return classes;
	}

	function parseValue (arg) {
		if (typeof arg === 'string' || typeof arg === 'number') {
			return arg;
		}

		if (typeof arg !== 'object') {
			return '';
		}

		if (Array.isArray(arg)) {
			return classNames.apply(null, arg);
		}

		if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
			return arg.toString();
		}

		var classes = '';

		for (var key in arg) {
			if (hasOwn.call(arg, key) && arg[key]) {
				classes = appendClass(classes, key);
			}
		}

		return classes;
	}

	function appendClass (value, newClass) {
		if (!newClass) {
			return value;
		}
	
		if (value) {
			return value + ' ' + newClass;
		}
	
		return value + newClass;
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 22875:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = '';

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (arg) {
				classes = appendClass(classes, parseValue(arg));
			}
		}

		return classes;
	}

	function parseValue (arg) {
		if (typeof arg === 'string' || typeof arg === 'number') {
			return arg;
		}

		if (typeof arg !== 'object') {
			return '';
		}

		if (Array.isArray(arg)) {
			return classNames.apply(null, arg);
		}

		if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
			return arg.toString();
		}

		var classes = '';

		for (var key in arg) {
			if (hasOwn.call(arg, key) && arg[key]) {
				classes = appendClass(classes, key);
			}
		}

		return classes;
	}

	function appendClass (value, newClass) {
		if (!newClass) {
			return value;
		}
	
		if (value) {
			return value + ' ' + newClass;
		}
	
		return value + newClass;
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ })

}]);